import { render } from "./USpinner.vue?vue&type=template&id=4b08d615"
const script = {}

import "./USpinner.vue?vue&type=style&index=0&id=4b08d615&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__